import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { BannerProps } from './banner-notification.component';

type BannerNotificationStylesProps = {
  status: BannerProps['status'];
  fullWidth: boolean;
};

const statusColors = {
  warn: theme.colors.warning5,
  success: theme.colors.success5,
  error: theme.colors.critical5,
  info: theme.colors.primary5,
};

const statusBorderColors = {
  warn: theme.colors.warning50,
  success: theme.colors.success50,
  error: theme.colors.critical50,
  info: theme.colors.primary50,
};

const style = ({ fullWidth, status }: BannerNotificationStylesProps) => css`
  max-width: ${fullWidth ? '100%' : '700px'};
  background-color: ${statusColors[status]};
  color: ${theme.colors.neutral90};
  display: flex;
  gap: ${theme.spacing(2)};
  padding: ${theme.spacing(2)};
  border: 1px solid ${statusBorderColors[status]};
  border-radius: ${theme.borderRadius.medium};
  align-items: center;
`;

export const BannerNotificationStyles = {
  bannerStyles: (props: BannerNotificationStylesProps) => style(props),
};
